export default "__VITE_ASSET__0631b58a__"